module.exports = __webpack_public_path__ + "static/Katah-9d0a4733047b010493e26e8b754a04bb.png";